import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const TicketInquiriesbyDate = asyncComponent(() => import('./TicketInquiriesbyDate'));
const CopyOfTicket = asyncComponent(() => import('./CopyOfTicket'));

const Report = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/TicketInquiriesbyDate`} component={TicketInquiriesbyDate} />
    <Route exact path={`${match.url}/CopyOfTicket`} component={CopyOfTicket} />
  </Switch>
);

export default Report;
